export const MCP_FILTER_EXPRESSION_SKILL_INSTRUCTION = 'Before writing filter expressions, read the `filter-expressions` skill.';
//# sourceMappingURL=mcpGuidance.js.map